module.exports = __webpack_public_path__ + "img/login_bac.b255c9f9.png";